<section class="background-color integration u-padding-16">
  <header class="integration__header line-height-24 u-font-size-16">
    Nova Biomedical - 15% discount exclusively for INSCYD users
    <div class="integration__subheader line-height-16 u-font-size-14">
      Visit the <a href="https://lactateplusmeter.store/" target="_blank">Lactate Plus Store</a> to place your order
    </div>
  </header>

  <div class="integration__content border-color background-color-intense u-margin-top-20 u-margin-bottom-8">
    <kbd>{{discountCode}}</kbd>
    <button mat-icon-button class="copy-button" (click)="copyToClipboard()" matTooltip="Copy to clipboard" aria-label="Copy to clipboard">
      <mat-icon>content_copy</mat-icon>
    </button>
  </div>

  <div>
    Thanks to the Partnership with Nova Biomedical YOU can benefit from a
    <strong>15% discount on all Nova lactate products</strong> - including the
    Nova LACTATE PLUS meters, test strips and accessories.
  </div>
  <div>
    The Nova LACTATE PLUS meter is currently the most accurate handheld lactate
    analyzer on the market.
  </div>
</section>
